import { PermissionCategory } from './../../enums/permission-category.enum';

export interface CreateCorporatePermissionDto {
  /** minLength: 0 | maxLength: 100 */
  name: string;

  /** minLength: 0 | maxLength: 500 */
  description?: string | null;

  category: PermissionCategory;

  isActive?: boolean;
}
